module.exports = __webpack_public_path__ + "static/media/new-arrivals.4fd93ad4.svg";